import AssessmentTemplate from '@pages/assessment/assessment-details/components/Template'
import AssistantPage from '@pages/assistant/AssistantPage'
import ClinicalPrint from '@pages/clinical-record/clinical-record-print'
import ClinicalLOAPrint from '@pages/clinical-record/clinical-record-print/PrintLOATemplate'
import PrintMedicalRequest from '@pages/clinical-record/clinical-record-print/PrintMedicalRequest'
import AccruedInterestStatementPrint from '@pages/disbursement/disbursement-funding/print/accruedInterestStatement'
import DisbursementPrint from '@pages/disbursement/disbursement-funding/print/index'
import OutstandingStatementPrint from '@pages/disbursement/disbursement-funding/print/outstandingStatement'
import AdvancePrint from '@pages/disbursement/facility-agreements/detail/advance-print'
import RepaymentInvoicePrint from '@pages/disbursement/transaction-invoice/print/index'
import InvoiceSummaryPrint from '@pages/disbursement/transaction-invoice/print/invoiceSummary'
import OutstandingStatementRepaymentInvoice from '@pages/disbursement/transaction-invoice/print/outstandingStatement'
import DaySheetPrint from '@pages/doctor-routes/DaySheetPrint'
import InvoicePrint from '@pages/invoice/invoice-print'
import OutstandingStatementPrintInvoice from '@pages/invoice/invoice-print/outstandingStatement'
import MvaTemplate from '@pages/mva-claim/detail/components/Template'
import NdisTemplate from '@pages/ndis/details/components/Template'
import PrintSpecialistWithPayment from '@pages/specialist/specialist-remittance/PrintSpecialistWithPayment'
import SpecialistTemplate from '@pages/specialist/template'
import SupplementaryPrint from '@pages/supplementary/supplementary-print'
import VideoSession from '@pages/video-meeting/AppVideoMeeting'
import { ROLE_NAME } from '@utils/constants'

import { RouteConfig } from './interface'

export const EmptyRoutes: RouteConfig[] = [
  {
    // The AI Assistant on its own page ("Open in new window"); the page checks the feature.
    path: '/view/assistant',
    Component: AssistantPage,
    title: 'K-Assist',
  },
  {
    path: '/view/clinical-notes/print-letter-of-confirmation',
    Component: ClinicalPrint,
    title: 'Print Clinical',
    roles: [ROLE_NAME.ADMIN_STAFF, ROLE_NAME.STAFF, ROLE_NAME.CASE_MANAGER],
  },
  {
    path: '/view/clinical-notes/print-loa-template',
    Component: ClinicalLOAPrint,
    title: 'Print Clinical',
    roles: [ROLE_NAME.ADMIN_STAFF, ROLE_NAME.STAFF, ROLE_NAME.CASE_MANAGER],
  },
  {
    path: '/view/clinical-notes/print-medical-request',
    Component: PrintMedicalRequest,
    title: 'Print Medical Request',
    roles: [ROLE_NAME.ADMIN_STAFF, ROLE_NAME.STAFF, ROLE_NAME.CASE_MANAGER],
  },
  {
    path: '/view/invoices/print-invoice',
    Component: InvoicePrint,
    title: 'Print Invoice',
    roles: [
      ROLE_NAME.ADMIN_STAFF,
      ROLE_NAME.STAFF,
      ROLE_NAME.CASE_MANAGER,
      ROLE_NAME.SPECIALIST,
    ],
  },
  {
    path: '/view/invoices/outstanding-statement-print',
    Component: OutstandingStatementPrintInvoice,
    title: 'Print Outstanding statement',
    roles: [
      ROLE_NAME.ADMIN_STAFF,
      ROLE_NAME.STAFF,
      ROLE_NAME.CASE_MANAGER,
      ROLE_NAME.SPECIALIST,
    ],
  },
  {
    path: '/view/daysheet-print',
    Component: DaySheetPrint,
    title: 'Booking Daysheet',
    roles: [
      ROLE_NAME.ADMIN_STAFF,
      ROLE_NAME.STAFF,
      ROLE_NAME.SPECIALIST,
      ROLE_NAME.CASE_MANAGER,
    ],
  },
  {
    path: '/view/disbursement-print',
    Component: DisbursementPrint,
    title: 'Funding Transaction Invoice',
    roles: [ROLE_NAME.ADMIN_STAFF, ROLE_NAME.STAFF, ROLE_NAME.CASE_MANAGER],
  },
  {
    path: '/view/repaymentinvoice-print',
    Component: RepaymentInvoicePrint,
    title: 'Funding Transaction Invoice',
    roles: [ROLE_NAME.ADMIN_STAFF, ROLE_NAME.STAFF, ROLE_NAME.CASE_MANAGER],
  },
  {
    path: '/view/repaymentinvoice-summary-print',
    Component: InvoiceSummaryPrint,
    title: 'Funding Transaction Invoice',
    roles: [ROLE_NAME.ADMIN_STAFF, ROLE_NAME.STAFF, ROLE_NAME.CASE_MANAGER],
  },
  {
    path: '/view/outstanding-statement-print',
    Component: OutstandingStatementPrint,
    title: 'Outstanding Statement',
    roles: [ROLE_NAME.ADMIN_STAFF, ROLE_NAME.STAFF, ROLE_NAME.CASE_MANAGER],
  },
  {
    path: '/view/repaymentinvoice/outstanding-statement-print',
    Component: OutstandingStatementRepaymentInvoice,
    title: 'Outstanding Statement',
    roles: [ROLE_NAME.ADMIN_STAFF, ROLE_NAME.STAFF, ROLE_NAME.CASE_MANAGER],
  },
  {
    path: '/view/disbursement-funding/accrued-interest-statement-print',
    Component: AccruedInterestStatementPrint,
    title: 'Print Accrued Interest Statement',
    roles: [ROLE_NAME.ADMIN_STAFF, ROLE_NAME.STAFF, ROLE_NAME.CASE_MANAGER],
  },
  {
    path: '/view/ime-assessment/template',
    Component: AssessmentTemplate,
    title: 'Assessment Template',
  },
  {
    path: '/view/supplementary/print',
    Component: SupplementaryPrint,
    title: 'Supplementary Print',
    roles: [ROLE_NAME.ADMIN_STAFF, ROLE_NAME.STAFF, ROLE_NAME.CASE_MANAGER],
  },
  {
    path: '/view/agreement-advance/print',
    Component: AdvancePrint,
    title: 'Agreement Print',
  },
  {
    path: '/view/video-old',
    Component: VideoSession,
    title: 'View Video',
  },
  {
    path: '/view/specialist-remittance/print',
    Component: PrintSpecialistWithPayment,
    title: 'Print Specialist With Payment',
    roles: [ROLE_NAME.ADMIN_STAFF, ROLE_NAME.STAFF],
  },
  {
    path: '/view/mva/template',
    Component: MvaTemplate,
    title: 'Mva Template',
    roles: [ROLE_NAME.ADMIN_STAFF, ROLE_NAME.STAFF, ROLE_NAME.CASE_MANAGER],
  },
  {
    path: '/view/ndis/template',
    Component: NdisTemplate,
    title: 'Ndis Template',
  },
  {
    path: '/view/specialist/template',
    Component: SpecialistTemplate,
    title: 'Specialist Template',
  },
]
